/**
 * The asynchronous hours, as people read them: "1 oră", "1,5 ore", "80,0%".
 * The arithmetic itself is the server's (services/portal/attendance.py).
 */

export function hoursText(h) {
  const n = Math.round((Number(h) || 0) * 100) / 100;
  if (n === 1) return "1 oră";
  return `${String(n).replace(".", ",")} ore`;
}

export function percentText(p) {
  return `${(Number(p) || 0).toFixed(1).replace(".", ",")}%`;
}

/** What goes in the hours field: quarter hours, 0 to 10. Null if not a number. */
export function parseHours(value) {
  const n = Number(String(value ?? "").replace(",", "."));
  if (!Number.isFinite(n)) return null;
  return Math.min(10, Math.max(0, Math.round(n * 4) / 4));
}

/** "6 din 10 ore configurate" — the line under the group's heading. */
export function configuredLine(report) {
  if (!report) return "";
  return `Activitățile marcate însumează ${hoursText(report.configured_hours)} din ${hoursText(report.required_hours)} cerute`;
}
